module.exports = __webpack_public_path__ + "img/oufu_85x110x12.prt.af65b6c7.jpg";